export default __webpack_public_path__ + "static/layout-f2a273f47e0c9a7c2449440e51536e53.png";